import React from 'react';
import { FormControlLabel, RadioGroup, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomRadio from '../../forms/theme-elements/CustomRadio';

export default function CusRadioGroup({ label, options, value, setValue }) {
  const { t } = useTranslation();

  return (
    <Stack>
      <Typography color="textSecondary">{t(label)}</Typography>
      <RadioGroup
        row
        aria-label={label}
        name={label}
        value={value}
        onChange={(_, value) => setValue(value)}>
        {options.map((el) => (
          <FormControlLabel
            key={el.value}
            value={el.value}
            control={<CustomRadio />}
            label={t(el.label)}
          />
        ))}
      </RadioGroup>
    </Stack>
  );
}
